"use client";

import { useMemo } from "react";
import { toCurrentUser } from "../api/session";
import { useMe } from "./useConversations";

export type { CurrentUser } from "../api/session";
/** `GET /me` itself, for code that has moved to the v1 vocabulary. */
export { useMe, meKey } from "./useConversations";

/**
 * THE LEGACY VIEW OF `GET /me`, AND IT IS ON ITS WAY OUT.
 *
 * ONE REQUEST, TWO VOCABULARIES. `useMe()` already polls `GET /me`
 * conditionally at the cadence the server sets (§1.10 / D12) and is the only
 * place the badge counters are read; this hook is a projection of that same
 * query, not a second one. The twenty-odd components that still expect
 * `{id, username, name, avatar_template, admin}` keep working while their own
 * domains move, and `toCurrentUser`'s header says exactly what `username` and
 * `avatar_template` really are now.
 *
 * WHAT WENT: `GET /session/current.json`, the 403/404-means-signed-out catch
 * (signed-out is `null` in v1, never an error — §1.6) and the retry predicate
 * that inspected a raw `Response`.
 *
 * NOTE FOR WHOEVER MOVES THE REST: the query key is `meKey`
 * (`["v1", "me"]`), not `["currentUser"]`. Invalidate that.
 */
export function useCurrentUser() {
  const query = useMe();
  const data = useMemo(
    () => (query.data ? toCurrentUser(query.data) : null),
    [query.data],
  );
  return { ...query, data };
}
